import AccountCircleIcon from '@material-ui/icons/AccountCircle'
const UserImage = (props) => {
    const { Src = "", SrcSocial = "" } = props
    if (SrcSocial !== "")
        return (
            <img src={`${SrcSocial}`} alt="userProfile"  style={{width: "100%", height:"auto", maxWidth: "50px"}}/>
        )
    if (Src !== "")
        return (
            <img src={`${Src}`} alt="userProfile"  style={{width: "100%", height:"auto", maxWidth: "50px"}}/>
        )
    return (
        <AccountCircleIcon style={{width: "100%", height:"auto", maxWidth: "50px"}}/>
    )
}
export default UserImage